import { CloseIcon, Grid, Typography } from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import PropTypes from 'prop-types'
import React, { useState } from 'react'

import styles from './styles'

const useStyles = makeStyles(styles)

const Notification = ({ notification }) => {
  const classes = useStyles()
  const [displayed, setDisplayed] = useState(true)

  return displayed && (
    <div
      className={classes.container}
      style={{ background: notification.backgroundColor }}
    >
      <Grid
        direction="row"
        alignItems="center"
        wrap="nowrap"
        className={classes.wrapper}
      >
        <img
          src={notification.icon}
          alt="Notification icon"
          className={classes.icon}
        />
        <div className={classes.text}>
          <Typography weight="bold">{notification.title}</Typography>
          <Typography html={notification.content[0].content} />
        </div>
        <div
          className={classes.closeButton}
          onClick={() => setDisplayed(false)}
        >
          <CloseIcon fontSize="small" />
        </div>
      </Grid>
    </div>
  )
}

Notification.defaultProps = {
  notification: PropTypes.object.isRequired,
}

export default Notification
